<template>
  <div>
    <PageHeader :title="title" :items="itemsPageHeader" />
    <p>
      Don't forget import <code>custom.css</code> or use <code>cdn ......</code>
    </p>
    <div class="row">
      <!-- input -->
      <div class="col-12">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-3">Input</h4>
              <b-card
                header-class="bg-transparent border-info"
                class="border border-info"
              >
                <div class="quote-code" v-if="selectInput === 1">
                  <span>&lt;</span>div role="<code>group</code>"
                  class="<code>input-group</code>"<span>&gt;</span>
                  <div class="ml-4">
                    <span>&lt;</span>div
                    class="<code>input-group-prepend</code>"<span>&gt;</span>
                    <div class="ml-4">
                      <span>&lt;</span>div
                      class="<code>input-group-text</code>"<span>&gt;</span>
                      <div class="ml-4">
                        <code class="text-success">TH</code>
                      </div>
                      <span>&lt;</span>/div<span>&gt;</span>
                    </div>
                    <span>&lt;</span>/div<span>&gt;</span>
                    <div class="">
                      <span>&lt;</span>input type="<code>text</code>"
                      class="<code>form-control</code>"
                      v-model="<code>example.text.th</code>" /<span>&gt;</span>
                    </div>
                  </div>
                  <span>&lt;</span>/div<span>&gt;</span>
                </div>
                <div class="quote-code" v-if="selectInput === 2">
                  <span>&lt;</span>div class="<code
                    >input-group check-length</code
                  >"<span>&gt;</span>
                  <div class="ml-4">
                    <span>&lt;</span>input type="<code>text</code>"
                    class="<code>form-control</code>"
                    v-model="<code>example.text.en></code>"
                    maxlength="<code>30</code>" /<span>&gt;</span>
                  </div>
                  <div class="ml-4">
                    <span>&lt;</span>span
                    class="<code>input-validate-length</code>"<span>&gt;</span>
                    {{ example.text.th.length }}/30 <span>&lt;</span>/span<span
                      >&gt;</span
                    >
                  </div>
                  <span>&lt;</span>/div<span>&gt;</span>
                </div>
              </b-card>
              <div class="row">
                <div class="col-sm-3">
                  <div
                    role="group"
                    class="input-group"
                    @click="selectInput = 1"
                  >
                    <span class="input-group-prepend">
                      <div class="input-group-text">
                        TH
                      </div>
                    </span>
                    <input
                      type="text"
                      class="form-control"
                      v-model="example.text.th"
                    />
                  </div>
                </div>
                <div class="col-sm-3">
                  <div
                    class="input-group check-length"
                    @click="selectInput = 2"
                  >
                    <input
                      type="text"
                      class="form-control"
                      v-model="example.text.en"
                      maxlength="30"
                    />
                    <span class="input-validate-length"
                      >{{ example.text.en.length }}/30</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- input search -->
      <div class="col-12">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-3">Input Search</h4>
              <b-card
                header-class="bg-transparent border-info"
                class="border border-info"
              >
                <div class="quote-code">
                  <template v-if="selectSearch === 1">
                    <span>&lt;</span>div role="<code>group</code>"
                    class="<code>input-group</code>"<span>&gt;</span>
                    <div class="ml-4">
                      <div class="">
                        <span>&lt;</span>input type="<code>text</code>"
                        class="<code>form-control</code>"
                        v-model="<code>example.search.btn</code>" /<span
                          >&gt;</span
                        >
                      </div>
                      <span>&lt;</span>span class="<code
                        >input-group-append pointer</code
                      >" @click="<code class="text-info">function</code>"
                      <span>&gt;</span>
                      <div class="ml-4">
                        <span>&lt;</span>span
                        class="<code>input-group-text</code>"<span>&gt;</span>
                        <div class="ml-4">
                          <span>&lt;</span>i class="<code>bx bx-search</code>"
                          /<span>&gt;</span>
                        </div>
                        <span>&lt;</span>/div<span>&gt;</span>
                      </div>
                      <span>&lt;</span>/div<span>&gt;</span>
                    </div>
                    <span>&lt;</span>/div<span>&gt;</span>
                  </template>
                  <template v-if="selectSearch === 2">
                    <span>&lt;</span>div role="<code>group</code>" class="<code
                      >input-group input-icon</code
                    >"<span>&gt;</span>
                    <div class="ml-4">
                      <div class="">
                        <span>&lt;</span>input type="<code>text</code>"
                        class="<code>form-control</code>"
                        v-model="<code>example.search.icon</code>" /<span
                          >&gt;</span
                        >
                      </div>
                      <span>&lt;</span>i class="<code>bx bx-search</code>"
                      /<span>&gt;</span>
                    </div>
                    <span>&lt;</span>/div<span>&gt;</span>
                  </template>
                </div>
              </b-card>
              <div class="row">
                <div class="col-sm-3">
                  <div class="input-group" @click="selectSearch = 1">
                    <input
                      type="text"
                      class="form-control"
                      v-model="example.search.btn"
                    />
                    <span class="input-group-append pointer">
                      <span class="input-group-text">
                        <i class="bx bx-search f-16" />
                      </span>
                    </span>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="input-group input-icon" @click="selectSearch = 2">
                    <input
                      type="text"
                      class="form-control"
                      v-model="example.search.icon"
                    />
                    <i class="bx bx-search" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- input validate -->
      <div class="col-12">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-3">Validate Input</h4>
              <b-card
                header-class="bg-transparent border-info"
                class="border border-info"
              >
                <div class="quote-code">
                  <span>&lt;</span>validationProvider v-slot="<code
                    >{ errors }</code
                  >" :rules="<code
                    >{ dynamicRequired: ['กรุณากรอกข้อมูล'] }</code
                  >"<span>&gt;</span>
                  <div class="ml-4">
                    <span>&lt;</span>div class="<code>input-group</code>"<span
                      >&gt;</span
                    >
                    <div class="ml-4">
                      <div>
                        <span>&lt;</span>input type="<code>text</code>"
                        class="<code>form-control</code>"
                        v-model="<code>example.text.validate</code>"
                        :class="<code
                          >{ 'is-invalid': errors.length, 'is-valid':
                          !errors.length && example.text.validate, }</code
                        >" /<span>&gt;</span>
                      </div>
                      <div>
                        <span>&lt;</span>span v-if="<code>errors.length</code>"
                        class="<code>validate-invalid</code>"
                        v-html="<code>errors[0]</code>"
                        <span>&gt;</span>
                        <span>&lt;</span>/span<span>&gt;</span>
                      </div>
                    </div>
                    <span>&lt;</span>/div<span>&gt;</span>
                  </div>
                  <span>&lt;</span>/validationProvider<span>&gt;</span>
                </div>
              </b-card>
              <div class="row">
                <div class="col-sm-3">
                  <validationProvider
                    v-slot="{ errors }"
                    :rules="{ dynamicRequired: ['กรุณากรอกข้อมูล'] }"
                  >
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        v-model="example.text.validate"
                        placeholder="Validate Empty"
                        :class="{
                          'is-invalid': errors.length,
                          'is-valid': !errors.length && example.text.validate,
                        }"
                      />
                      <span
                        v-if="errors.length"
                        class="validate-invalid"
                        v-html="errors[0]"
                      ></span>
                    </div>
                  </validationProvider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Button -->
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Button</h4>
            <b-card
              header-class="bg-transparent border-info"
              class="border border-info"
            >
              <div class="quote-code" v-if="!isButtonCode">
                <span>&lt;</span>button type="<code>button</code>" class="<code
                  >btn btn-{{ example.button.class }}</code
                >"<span>&gt;</span><span>&lt;</span>i class="<code>{{
                  example.button.icon
                }}</code
                >"/<span>&gt;</span
                ><code class="text-success">{{ example.button.text }}</code
                ><span>&lt;</span>/button<span>&gt;</span>
              </div>
              <!-- btn table -->
              <div class="quote-code" v-else>
                <div>
                <span>&lt;</span>button type="<code>button</code>"
                  class="<code>btn btn-sm</code>"
                  @click="<code>isHide = !isHide</code>"
                  :class="<code>isHide ? 'btn-secondary' : 'btn-info'</code>"
                <span>&gt;</span>
                </div>
                <div class="ml-4">
                  <code class="text-success">&#123;</code>
                  <code class="text-success">&#123;</code> <code class="text-success">isHide ? 'Hide' : 'More'</code>
                  <code class="text-success">&#125;</code>
                  <code class="text-success">&#125;</code> <span>&lt;</span>i :title="<code>isHide ? 'Hide Detail' : 'More Detail'
                  </code>" :class="<code>isHide ? 'bx bx-caret-down' : 'bx bx-caret-right'</code>
                  
                  "/<span>&gt;</span
                  >
                </div>
                <span>&lt;</span>/button<span>&gt;</span>
              </div>
              <!-- btn table -->
            </b-card>
            <div class="button-items">
              <div>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="isButtonCode = false;onExampleBtn('primary', 'bx bx-search', 'Search')"
                >
                  <i class="bx bx-search" />
                  Search
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="isButtonCode = false;onExampleBtn('primary', 'bx bx-save', 'Save')"
                >
                  <i class="bx bx-save" />
                  Save
                </button>
                <button
                  type="button"
                  class="btn btn-info"
                  @click="isButtonCode = false;onExampleBtn('info', 'bx bx-show', 'View')"
                >
                  <i class="bx bx-show" />
                  View
                </button>
                <button
                  type="button"
                  class="btn btn-info"
                  @click="isButtonCode = false;onExampleBtn('info', 'bx bx-check-double', 'Apply')"
                >
                  <i class="bx bx-check-double" />
                  Apply
                </button>
                <button
                  type="button"
                  class="btn btn-success"
                  @click="isButtonCode = false;onExampleBtn('success', 'bx bx-plus', 'New')"
                >
                  <i class="bx bx-plus" />
                  New
                </button>
                <button
                  type="button"
                  class="btn btn-success"
                  @click="isButtonCode = false;onExampleBtn('success', 'bx bx-plus', 'Add')"
                >
                  <i class="bx bx-plus" />
                  Add
                </button>
                <button
                  type="button"
                  class="btn btn-warning"
                  @click="isButtonCode = false;onExampleBtn('warning', 'bx bx-edit-alt', 'Edit')"
                >
                  <i class="bx bx-edit-alt" />
                  Edit
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="isButtonCode = false;onExampleBtn('danger', 'bx bx-trash', 'Delete')"
                >
                  <i class="bx bx-trash" />
                  Delete
                </button>
                <button
                  type="button"
                  class="btn btn-secondary"
                  @click="
                    isButtonCode = false;onExampleBtn(
                      'secondary',
                      'bx bx-dots-vertical-rounded',
                      'More'
                    )
                  "
                >
                  <i class="bx bx-dots-vertical-rounded" />
                  More
                </button>
                <button
                  type="button"
                  class="btn btn-light"
                  @click="isButtonCode = false;onExampleBtn('light', 'bx bx-reset', 'Reset')"
                >
                  <i class="bx bx-reset" />
                  Reset
                </button>
                <button
                  type="button"
                  class="btn btn-light"
                  @click="isButtonCode = false;onExampleBtn('light', 'bx bx-reset', 'Clear')"
                >
                  <i class="bx bx-reset" />
                  Clear
                </button>
                <button
                  type="button"
                  class="btn btn-light"
                  @click="isButtonCode = false;onExampleBtn('light', 'bx bx-arrow-back', 'Back')"
                >
                  <i class="bx bx-arrow-back" />
                  Back
                </button>
                <button
                  type="button"
                  class="btn btn-light"
                  @click="isButtonCode = false;onExampleBtn('light', 'bx bx-x-circle', 'Cancel')"
                >
                  <i class="bx bx-x-circle" />
                  Cancel
                </button>
              </div>
              <div>
                <button
                  type="button"
                  class="btn btn-upload"
                  @click="
                    isButtonCode = false;onExampleBtn(
                      'upload',
                      'bx bx-upload',
                      'Upload'
                    )
                  "
                >
                  <i class="bx bx-upload" />
                  Upload
                </button>
                <button
                  type="button"
                  class="btn btn-download-template"
                  @click="
                    isButtonCode = false;onExampleBtn(
                      'download-template',
                      'mdi mdi-download',
                      'Download Template'
                    )
                  "
                >
                  <i class="mdi mdi-download" />
                  Download Template
                </button>
                <button
                  type="button"
                  class="btn btn-clone"
                  @click="isButtonCode = false;onExampleBtn('clone', 'bx bx-copy', 'Clone')"
                >
                  <i class="bx bx-copy" />
                  Clone
                </button>
                <button
                  type="button"
                  class="btn btn-send-approve"
                  @click="
                    isButtonCode = false;onExampleBtn(
                      'send-approve',
                      'bx bx-user-check',
                      'Send to Approve'
                    )
                  "
                >
                  <i class="bx bx-user-check" />
                  Send to Approve
                </button>
                <button
                  type="button"
                  class="btn btn-approve"
                  @click="isButtonCode = false;onExampleBtn('approve', 'bx bx-check', 'Approve')"
                >
                  <i class="bx bx-check" />
                  Approve
                </button>
                <button
                  type="button"
                  class="btn btn-reject"
                  @click="isButtonCode = false;onExampleBtn('reject', 'bx bx-block', 'Reject')"
                >
                  <i class="bx bx-block" />
                  Reject
                </button>
              </div>
              <div>
                <button
                  type="button"
                  class="btn btn-upload  btn-sm"
                  @click="
                    isButtonCode = false;onExampleBtn(
                      'upload  btn-sm',
                      'bx bx-upload',
                      'Upload'
                    )
                  "
                >
                  <i class="bx bx-upload" />
                  Upload
                </button>
                <button
                  class="btn btn-sm"
                  type="button"
                  @click="isHide = !isHide;isButtonCode = true"
                  :class="isHide ? 'btn-secondary' : 'btn-info'"
                >
                  {{ isHide ? 'Hide' : 'More' }}
                  <i
                    :class="isHide ? 'bx bx-caret-down' : 'bx bx-caret-right'"
                    :title="isHide ? 'Hide Detail' : 'More Detail'"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Icon -->
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Icon</h4>
            <b-card
              header-class="bg-transparent border-info"
              class="border border-info"
            >
              <div class="quote-code">
                <span>&lt;</span>a title="<code>{{example.icon.text}}</code>" class="<code
                  >btn btn-ico {{ example.icon.class }}</code
                >"<span>&gt;</span><span>&lt;</span>i class="<code>{{
                  example.icon.icon
                }}</code
                >"/<span>&gt;</span
                >
                <span>&lt;</span>/a<span>&gt;</span>
              </div>
            </b-card>
            <div>
              <span class="mr-1" @click="example.icon = { class: 'text-info', icon: 'bx bx-show', text: 'View',}">
                <a title="View" class="btn btn-ico text-info"><i class="bx bx-show"/></a>
              </span>
              <span class="mr-1" @click="example.icon = { class: 'text-warning', icon: 'bx bx-edit-alt', text: 'Edit',}">
                <a title="Edit" class="btn btn-ico text-warning"><i class="bx bx-edit-alt"/></a>
              </span>
              <span class="mr-1" @click="example.icon = { class: 'text-danger', icon: 'bx bx-trash', text: 'Delete',}">
                <a title="Delete" class="btn btn-ico text-danger"><i class="bx bx-trash"/></a>
              </span>
              <span class="mr-1" @click="example.icon = { class: 'text-secondary', icon: 'mdi mdi-download', text: 'Download',}">
                <a title="Download" class="btn btn-ico text-secondary"><i class="mdi mdi-download"/></a>
              </span>
              <span class="mr-1" @click="example.icon = { class: 'text-warning-2', icon: 'bx bx-copy', text: 'Clone',}">
                <a title="Clone" class="btn btn-ico text-warning-2"><i class="bx bx-copy"/></a>
              </span>
              <span class="mr-1" @click="example.icon = { class: 'text-primary', icon: 'bx bx-search', text: 'Search',}">
                <a title="Search" class="btn btn-ico text-primary"><i class="bx bx-search"/></a>
              </span>
              <span class="mr-1" @click="example.icon = { class: 'text-primary', icon: 'bx bx-upload', text: 'Upload',}">
                <a title="Upload" class="btn btn-ico text-primary"><i class="bx bx-upload"/></a>
              </span>

            </div>
          </div>
        </div>
      </div>
      <!-- Tooltip -->
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Tooltip</h4>
            <b-card
              header-class="bg-transparent border-info"
              class="border border-info"
            >
              <div class="quote-code">
                <div class="user-select-none mb-2">
                  use <code>variant</code> with <code>info</code> ,
                  <code>danger</code> , <code>warning</code> ,
                  <code>secondary</code> , <code>light</code> ,
                  <code>dark</code>
                </div>
                <div class="user-select-none mb-2">
                  use <code>placement</code> with <code>left</code> ,
                  <code>right</code> , <code>top</code> , <code>bottom</code>
                </div>
                <tamplate v-if="isTooltipBtn">
                  <span>&lt;</span>button
                  id="<code>tooltip-button-variant</code>" class="<code
                    >btn btn-secondary</code
                  >"<span>&gt;</span>Button<span>&lt;</span>/button<span
                    >&gt;</span
                  >
                  <div>
                    <span>&lt;</span>b-tooltip
                    target="<code>tooltip-button-variant</code>"
                    variant="<code>danger</code>" placement="<code>top</code>">
                    <div class="ml-4">
                      <code class="text-success"
                        >Danger variant tooltip top</code
                      >
                    </div>
                    <span>&lt;</span>/b-tooltip<span>&gt;</span>
                  </div>
                </tamplate>
                <tamplate v-else>
                  <span>&lt;</span>i id="<code>tooltip-icon</code>" class="<code
                    >ml-2 bx bx-info-circle text-grey pointer f-18</code
                  >"/<span>&gt;</span>
                  <div>
                    <span>&lt;</span>b-tooltip
                    target="<code>tooltip-icon</code>"
                    variant="<code>info</code>" placement="<code>bottom</code>">
                    <div class="ml-4">
                      <code class="text-success"
                        >Info variant tooltip bottom</code
                      >
                    </div>
                    <span>&lt;</span>/b-tooltip<span>&gt;</span>
                  </div>
                </tamplate>
              </div>
            </b-card>
            <div class="text-left">
              <button
                id="tooltip-button-variant"
                class="btn btn-secondary"
                @click="isTooltipBtn = true"
              >
                Button
              </button>
              <b-tooltip
                target="tooltip-button-variant"
                variant="danger"
                placement="top"
                >Danger variant tooltip right</b-tooltip
              >

              <i
                id="tooltip-icon"
                class="ml-2 bx bx-info-circle text-grey pointer f-18"
                @click="isTooltipBtn = false"
              />
              <b-tooltip target="tooltip-icon" variant="info" placement="bottom"
                >Info variant tooltip bottom</b-tooltip
              >
            </div>
          </div>
        </div>
      </div>
      <!-- Browse -->
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Browse</h4>
            <b-card
              header-class="bg-transparent border-info"
              class="border border-info"
            >
              <div class="quote-code">
                <tamplate>
                  <div>
                    <span>&lt;</span>div class="<code>custom-file</code>"
                    <span>&gt;</span>
                  </div>
                  <div class="ml-4">
                    <div>
                      <span>&lt;</span>input ref="<code>customFile</code>
                      id="<code>customFile</code>" class="<code
                        >custom-file-input"</code
                      >
                      type="<code>file</code>" @change="<code class="text-info"
                        >previewFiles</code
                      >" /">
                    </div>
                    <div>
                      <span>&lt;</span>label
                      class="<code>custom-file-label</code>"
                      for="<code>customFile</code>"
                      <span>&gt;</span>
                    </div>
                    <div
                      class="ml-4"
                      v-html="
                        '{{ <code>files.length</code> ? <code>files[0].name</code> : <code>\'Choose file\'</code> }}'
                      "
                    ></div>
                    <div><span>&lt;</span>/label<span>&gt;</span></div>
                  </div>
                  <div><span>&lt;</span>/div<span>&gt;</span></div>

                  <!-- script -->
                  <div class="mt-4">
                    <div class="user-select-none mb-2">
                      Add <code>data</code>,
                      <code>methods</code>
                    </div>
                    data() {
                    <div class="ml-4">
                      return {
                      <div class="ml-4">
                        <div>
                          files: []
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="ml-4">
                    },
                  </div>
                  <div>
                    },
                  </div>
                  <div class="">
                    methods: {
                    <div class="ml-4">
                      previewFiles() {
                      <div class="ml-4">
                        <div>
                          <span class="text-info">this</span>.files =
                          <code>this.$refs.customFile.files</code>
                        </div>
                      </div>
                      <div>
                        }
                      </div>
                    </div>
                    <div>
                      }
                    </div>
                  </div>
                </tamplate>
              </div>
            </b-card>
            <div class="row">
              <div class="col-sm-3">
                <div class="custom-file">
                  <input
                    id="customFile"
                    type="file"
                    class="custom-file-input"
                    ref="customFile"
                    @change="previewFiles"
                  />
                  <label class="custom-file-label" for="customFile">
                    {{ files.length ? files[0].name : 'Choose file' }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Dropdown -->
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Dropdown Button</h4>
            <b-card
              header-class="bg-transparent border-info"
              class="border border-info"
            >
              <div class="quote-code">
                <div class="user-select-none mb-2">
                  use <code>left</code> or <code>right</code> to align
                  dropdown-item
                </div>
                <span>&lt;</span>b-dropdown class="<code>btn-export</code>"
                <code>left</code><span>&gt;</span>
                <div style="margin-left:2rem;">
                  <span>&lt;</span>template
                  slot="<code>button-content</code>"<span>&gt;</span
                  ><span>&lt;</span>i class="<code>bx bx bx-file</code>" /<span
                    >&gt;</span
                  ><code class="text-success">Export</code><span>&lt;</span>i
                  class="<code>mdi mdi-chevron-down</code>"
                  /><span>&lt;</span>/template<span>&gt;</span>
                </div>
                <div style="margin-left:2rem;">
                  <span>&lt;</span>b-dropdown-item><span>&lt;</span>i
                  class="<code>far fa-file-excel text-success</code>" /<span
                    >&gt;</span
                  ><code class="text-success">Excel</code
                  ><span>&lt;</span>/b-dropdown-item<span>&gt;</span>
                </div>
                <div style="margin-left:2rem;">
                  <span>&lt;</span>b-dropdown-item><span>&lt;</span>i
                  class="<code>far fa-file-pdf text-danger</code>" /<span
                    >&gt;</span
                  ><code class="text-success">PDF</code
                  ><span>&lt;</span>/b-dropdown-item<span>&gt;</span>
                </div>
                <span>&lt;</span>/b-dropdown<span>&gt;</span>
              </div>
            </b-card>
            <div class="button-items">
              <b-dropdown class="btn-export">
                <template slot="button-content">
                  <i class="bx bx bx-file"/>
                  Export
                  <i class="mdi mdi-chevron-down"
                /></template>
                <b-dropdown-item
                  ><i class="far fa-file-excel text-success" />Excel
                </b-dropdown-item>
                <b-dropdown-item
                  ><i class="far fa-file-pdf text-danger" />PDF
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>
      </div>
      <!-- Switches -->
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Switches Radio</h4>
            <b-card
              header-class="bg-transparent border-info"
              class="border border-info"
            >
              <div class="quote-code">
                <span>&lt;</span>switches
                v-model="<code>switches.default</code>"
                type-bold="<code>true</code>" color="<code>info</code>"
                class="<code>switch-inner-label custom-switches</code>
                <template v-if="example.switches.isSmall"
                  ><code class="text-success"> switches-small</code></template
                >" text-enabled="<code class="text-success"
                  ><template v-if="example.switches.isSmall">Yes</template
                  ><template v-else>Active</template></code
                >" text-disabled="<code class="text-success"
                  ><template v-if="example.switches.isSmall">No</template
                  ><template v-else>Inactive</template></code
                >" /<span>&gt;</span>
                <div class="mt-2">
                  <code>import</code>
                  <code class="text-success"> Switches</code> <code>from</code>
                  <code class="text-success"> 'vue-switches'</code>
                </div>
              </div>
            </b-card>
            <div class="">
              <span class="mr-4" @click="example.switches.isSmall = false">
                <switches
                  v-model="switches.default"
                  type-bold="true"
                  color="info"
                  class="switch-inner-label custom-switches "
                  text-enabled="Active"
                  text-disabled="Inactive"
                />
              </span>
              <span @click="example.switches.isSmall = true">
                <switches
                  v-model="switches.small"
                  type-bold="true"
                  color="info"
                  class="switch-inner-label custom-switches switches-small"
                  text-enabled="Yes"
                  text-disabled="No"
                  @input="onConsoleLog($event)"
                />
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- Label Status -->
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Label Status</h4>
            <b-card
              header-class="bg-transparent border-info"
              class="border border-info"
            >
              <div class="quote-code">
                <span>&lt;</span>label class="<code
                  >label label-{{ example.status.class }}</code
                >"<span>&gt;</span
                ><code class="text-success">{{ example.status.text }}</code
                ><span>&lt;</span>/label<span>&gt;</span>
              </div>
            </b-card>
            <div class="row">
              <div class="col-12">
                <!-- status -->
                <div class="mb-2 bold">Status</div>
                <div class="label-items mb-2">
                  <label
                    class="label label-default pointer"
                    @click="onExampleStatus('default', 'Default')"
                    >Default</label
                  >
                  <label
                    class="label label-active pointer"
                    @click="onExampleStatus('active', 'Active')"
                    >Active</label
                  >
                  <label
                    class="label label-inactive pointer"
                    @click="onExampleStatus('inactive', 'Inctive')"
                    >Inctive</label
                  >
                  <label
                    class="label label-hold pointer"
                    @click="onExampleStatus('hold', 'Hold')"
                    >Hold</label
                  >
                  <label
                    class="label label-suspend pointer"
                    @click="onExampleStatus('suspend', 'Suspend')"
                    >Suspend</label
                  >
                  <label
                    class="label label-complete pointer"
                    @click="onExampleStatus('complete', 'Complete')"
                    >Complete</label
                  >
                  <label
                    class="label label-expire pointer"
                    @click="onExampleStatus('expire', 'Expire')"
                    >Expire</label
                  >
                  <label
                    class="label label-delete pointer"
                    @click="onExampleStatus('delete', 'Delete')"
                    >Delete</label
                  >
                  <label
                    class="label label-pending pointer"
                    @click="onExampleStatus('pending', 'Pending')"
                    >Pending</label
                  >
                  <label
                    class="label label-approve pointer"
                    @click="onExampleStatus('approve', 'Approve')"
                    >Approve</label
                  >
                  <label
                    class="label label-reject pointer"
                    @click="onExampleStatus('reject', 'Reject')"
                    >Reject</label
                  >
                  <label
                    class="label label-cancel pointer"
                    @click="onExampleStatus('cancel', 'Cancel')"
                    >Cancel</label
                  >
                  <label
                    class="label label-locked pointer"
                    @click="onExampleStatus('locked', 'Locked')"
                    >Locked</label
                  >
                  <label
                    class="label label-approval-request pointer"
                    @click="onExampleStatus('approval-request', 'Approval Request')"
                    >Approval Request</label
                  >
                </div>

                <!-- channel -->
                <div class="mb-2 bold">Channel</div>
                <div class="label-items mb-2">
                  <label
                    class="label label-offline pointer"
                    @click="onExampleStatus('offline', 'Offline')"
                    >Offline</label
                  >
                  <label
                    class="label label-online pointer"
                    @click="onExampleStatus('online', 'Online')"
                    >Online</label
                  >
                  <label
                    class="label label-store pointer"
                    @click="onExampleStatus('store', 'Store')"
                    >Store</label
                  >
                </div>
                <!-- vendor -->
                <div class="mb-2 bold">Vendor</div>
                <div class="label-items mb-2">
                  <label
                    class="label label-ofmstock pointer"
                    @click="onExampleStatus('ofmstock', 'OFMStock')"
                    >OFMStock</label
                  >
                  <label
                    class="label label-dropship pointer"
                    @click="onExampleStatus('dropship', 'DropShip')"
                    >DropShip</label
                  >
                  <label
                    class="label label-marketplace pointer"
                    @click="onExampleStatus('marketplace', 'MarketPlace')"
                    >MarketPlace</label
                  >
                </div>
                <!-- approval -->
                <!-- <div class="mb-2 bold">Approval</div> -->
                <!-- <div class="label-items mb-2">
                  <label
                    class="label label-pending pointer"
                    @click="onExampleStatus('pending', 'Pending')"
                    >Pending</label
                  >
                  <label
                    class="label label-approve pointer"
                    @click="onExampleStatus('approve', 'Approve')"
                    >Approve</label
                  >
                  <label
                    class="label label-reject pointer"
                    @click="onExampleStatus('reject', 'Reject')"
                    >Reject</label
                  >
                  <label
                    class="label label-cancel pointer"
                    @click="onExampleStatus('cancel', 'Cancel')"
                    >Cancel</label
                  >
                  <label
                    class="label label-locked pointer"
                    @click="onExampleStatus('locked', 'Locked')"
                    >Locked</label
                  >
                </div> -->
                <!-- Boolean -->
                <div class="mb-2 bold">Boolean</div>
                <div class="label-items">
                  <label
                    class="label label-yes pointer"
                    @click="onExampleStatus('yes', 'Yes')"
                    >Yes</label
                  >
                  <label
                    class="label label-no pointer"
                    @click="onExampleStatus('no', 'No')"
                    >No</label
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- editor -->
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Tinymce Editor</h4>
            <b-card
              header-class="bg-transparent border-info"
              class="border border-info"
            >
              <div class="quote-code">
                <span>&lt;</span>tinymce id="<code>tinymceEditor</code>"
                v-model="<code>tinymceEditor</code>"
                :plugins="<code>plugins</code>" :toolbar="<code>toolbar</code>"
                :other_options="<code>options</code>" /<span>&gt;</span>
                <div class="mt-4">
                  <div class="user-select-none mb-2">
                    Add <code>plugins</code>, <code>toolbar</code>,
                    <code>other_options</code> in data return
                  </div>
                  <!-- <div class="mt-2">
                    components: { Switches },
                  </div> -->
                  <div class="">
                    data() {
                    <div class="ml-4">
                      return {
                      <div class="ml-4">
                        <div>
                          plugins: [
                        </div>
                        <div class="ml-4">
                          '<code
                            >advlist autolink link image lists charmap print
                            preview hr anchor pagebreak spellchecker</code
                          >',
                        </div>
                        <div class="ml-4">
                          '<code
                            >searchreplace wordcount visualblocks visualchars
                            code fullscreen insertdatetime media
                            nonbreaking</code
                          >',
                        </div>
                        <div class="ml-4">
                          '<code
                            >save table contextmenu directionality emoticons
                            template paste textcolor</code
                          >',
                        </div>
                        <div>
                          ],
                        </div>
                        toolbar: '<code
                          >insertfile undo redo | styleselect | bold italic |
                          alignleft aligncenter alignright alignjustify |
                          bullist numlist outdent indent | l ink image | print
                          preview media fullpage | forecolor backcolor
                          emoticons</code
                        >',
                        <div>
                          options: {
                        </div>
                        <div class="ml-4">height: <code>200</code>,</div>
                        <!-- <div  class="ml-4">
                          style_formats: [
                          <div  class="ml-4">
                            { title: '<code>Bold text</code>', inline: '<code>b</code>' },
                          </div>
                            <div  class="ml-4">
                            { title: '<code>Red text</code>', inline: '<code>span</code>', styles: { color: '<code>#ff0000</code>' } },
                            </div>
                            <div  class="ml-4">
                            { title: '<code>Red header</code>', block: '<code>h1</code>', styles: { color: '<code>#ff0000</code>' } },
                            </div>
                            <div  class="ml-4">
                            { title: '<code>Example 1</code>', inline: '<code>span</code>', classes: '<code>example1</code>' },
                            </div>
                            <div  class="ml-4">
                            { title: '<code>Example 2</code>', inline: '<code>span</code>', classes: '<code>example2</code>' },
                            </div>
                            <div  class="ml-4">
                            { title: '<code>Table styles</code>' },
                            </div>
                            <div  class="ml-4">
                            { title: '<code>Table row 1</code>', selector: '<code>tr</code>', classes: '<code>tablerow1</code>' },
                            </div>
                          ],
                          </div> -->
                        <div>
                          },
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="ml-4">}</div>
                  <div>}</div>
                </div>
              </div>
            </b-card>
            <div>
              <tinymce
                id="tinymceEditor"
                v-model="tinymceEditor"
                :plugins="plugins"
                :toolbar="toolbar"
                :other_options="options"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- Vue-Multiselect -->
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">
              Vue-Multiselect (
              <a
                style="font-size:12px;"
                href="https://vue-multiselect.js.org/#sub-getting-started"
                target="_blank"
                >https://vue-multiselect.js.org/#sub-getting-started</a
              >
              )
            </h4>
            <b-card
              header-class="bg-transparent border-info"
              class="border border-info"
            >
              <div class="row">
                <div class="col-sm-12">
                  <div class="quote-code">
                    <span>&lt;</span>multiselect
                    <div class="ml-4">
                      <div v-if="disableMultiselect"><code>disabled</code></div>
                      <div>v-model="<code>multiselectData</code>"</div>
                      <div>:options="<code>optionsMultiselect</code>"</div>
                      <div>
                        :custom-label="<code>label => label.text</code>"
                      </div>
                      <div>:show-labels="<code>false</code>"</div>
                      <div>placeholder="<code>กรุณาเลือก</code>"</div>
                    </div>
                    /<span>&gt;</span>
                    <div class="mt-2">
                      <code>import</code>
                      <code class="text-success"> Multiselect</code>
                      <code>from</code>
                      <code class="text-success"> 'vue-multiselect'</code>
                    </div>
                    <div class="mt-2">
                      <div class="mt-2">
                        components: { Multiselect },
                      </div>
                      <div class="">
                        data() {
                        <div class="ml-4">
                          return {
                          <div class="ml-4">
                            <div>
                              multiselectData:
                              <template v-if="!example.multiselectData"
                                >''</template
                              ><template v-else
                                ><code
                                  class="text-info"
                                  v-html="example.multiselectData"
                                ></code></template
                              >,
                            </div>
                            <div>
                              optionsMultiselect: [
                            </div>
                            <div class="ml-4">
                              {
                              <span class="ml-2 mr-2"
                                >storeType: '<code>Good</code>', text: '<code
                                  >Main SubWH (Murata)</code
                                >', value: '<code>50001</code>',</span
                              >
                              },
                            </div>
                            <div class="ml-4">
                              {
                              <span class="ml-2 mr-2"
                                >storeType: '<code>Good</code>', text: '<code
                                  >Vendor stock-SubWH</code
                                >', value: '<code>50002</code>',</span
                              >
                              },
                            </div>
                            <div class="ml-4">
                              {
                              <span class="ml-2 mr-2"
                                >storeType: '<code>ReturnToVendor</code>', text:
                                '<code>RTV-SubWH</code>', value:
                                '<code>50004</code>', $isDisabled:
                                <code class="text-info">true</code>,</span
                              >
                              },
                            </div>
                            ],
                          </div>
                        </div>
                      </div>
                      <div class="ml-4">}</div>
                      <div>}</div>
                    </div>
                  </div>
                </div>
              </div>
            </b-card>
            <div class="row">
              <div class="col-sm-3">
                <multiselect
                  :disabled="disableMultiselect"
                  v-model="example.multiselectData"
                  :options="optionsMultiselect"
                  :custom-label="label => label.text"
                  :show-labels="false"
                  placeholder="กรุณาเลือก"
                />
              </div>
              <div class="col-sm-3">
                <button
                  class="btn btn-secondary"
                  @click="disableMultiselect = !disableMultiselect"
                >
                  <template v-if="disableMultiselect">Enable</template
                  ><template v-else>Disable</template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Calendar -->
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Date Range</h4>
            <b-card
              header-class="bg-transparent border-info"
              class="border border-info"
            >
              <div class="quote-code">
                <span>&lt;</span>date-range
                <div class="ml-4">
                  @selected="<code>onSelectedDate($event)</code>"
                </div>
                <div class="ml-4">
                  :default="<code>example.defaultDate</code>"
                </div>
                <div class="ml-4">
                  :is-invalid="<code>example.validateDateRange</code>"
                </div>
                <div class="ml-4">
                  invalid="<code>กรุณาเลือกวันที่</code>"
                </div>
                <div class="ml-4">
                  <code>date-time</code>
                  <span class="user-select-none ml-2"
                    >กรณีที่ต้องการเลือกวันที่และเวลา</span
                  >
                </div>
                <div>/<span>&gt;</span></div>
                <div class="mt-2">
                  <code>import</code> <code class="text-success">dateRange</code
                  ><code> from</code>
                  <code class="text-success"
                    >'@/components/share/date-range.vue'</code
                  >
                </div>
                <div class="mt-2">
                  components: { dateRange },
                </div>
                <div class="">
                  data() {
                  <div class="ml-4">
                    return {
                    <div class="ml-4">
                      <div>
                        example: {
                      </div>
                      <div class="ml-4">
                        defaultDate:
                        <code>[]</code>,
                      </div>
                      <div class="ml-4">
                        startDate: '',
                      </div>
                      <div class="ml-4">
                        endDate: '',
                      </div>
                      <div class="ml-4">
                        validateDateRange: <code>false</code>,
                      </div>
                      <div>
                        },
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ml-4">
                  },
                </div>
                <div>
                  },
                </div>
                <div class="">
                  methods: {
                  <div class="ml-4">
                    onSelectedDate(<code>value</code>) {
                    <div class="ml-4">
                      <div>
                        <span class="text-info">this</span>.example.startDate =
                        <code>value.from</code>
                      </div>
                      <div>
                        <span class="text-info">this</span>.example.endDate =
                        <code>value.to</code>
                      </div>
                      <div>
                        <span class="text-info">this</span>.example.startDate
                        <span class="text-success">&&</span>
                        <span class="text-info">this</span>.example.endDate
                        <span class="text-success">? </span>
                        <span class="text-info">this</span
                        >.example.validateDateRange = <code>false</code
                        ><span class="text-success"> : </span>
                        <span class="text-info">this</span
                        >.example.validateDateRange = <code>true</code>
                      </div>
                    </div>
                    <div>
                      }
                    </div>
                  </div>
                  <div>
                    }
                  </div>
                </div>
              </div>
            </b-card>
            <div class="row">
              <div class="col-sm-3">
                <date-range
                  @selected="onSelectedDate($event)"
                  :default="example.defaultDate"
                  :is-invalid="example.validateDateRange"
                  invalid="กรุณาเลือกวันที่"
                  :date-time="selectDateTime ? true : false"
                />
              </div>
              <div class="col-sm-3">
                <button
                  class="btn btn-secondary"
                  @click="selectDateTime = !selectDateTime"
                >
                  <template v-if="selectDateTime">Date</template
                  ><template v-else>Date Time</template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Calendar -->
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Date Base</h4>
            <b-card
              header-class="bg-transparent border-info"
              class="border border-info"
            >
              <div class="quote-code">
                <span>&lt;</span>date-base
                <div class="ml-4">
                  @selected="<code>onSelectedDateBase($event)</code>"
                </div>
                <div class="ml-4">
                  :is-invalid="<code>example.validateDateBase</code>"
                </div>
                <div class="ml-4">
                  invalid="<code>กรุณาเลือกวันที่</code>"
                </div>
                <div class="ml-4">
                  <code>date-time</code>
                  <span class="user-select-none ml-2"
                    >กรณีที่ต้องการเลือกวันที่และเวลา</span
                  >
                </div>
                <div class="ml-4">
                  <code>default-date</code>
                  <span class="user-select-none ml-2"
                    >กรณีที่ต้องการตั้งค่า
                    <code>Default</code> เป็นวันที่ปัจจุบัน</span
                  >
                </div>

                <div>/<span>&gt;</span></div>
                <div class="mt-2">
                  <code>import</code> <code class="text-success">dateBase</code
                  ><code> from</code>
                  <code class="text-success"
                    >'@/components/share/date-base.vue'</code
                  >
                </div>
                <div class="mt-2">
                  components: { dateBase },
                </div>
                <div class="">
                  data() {
                  <div class="ml-4">
                    return {
                    <div class="ml-4">
                      <div>
                        example: {
                      </div>
                      <div class="ml-4">
                        date:
                        <code>''</code>,
                      </div>
                      <div class="ml-4">
                        validateDateBase: <code>false</code>,
                      </div>
                      <div>
                        },
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ml-4">
                  },
                </div>
                <div>
                  },
                </div>
                <div class="">
                  methods: {
                  <div class="ml-4">
                    onSelectedDateBase(<code>value</code>) {
                    <div class="ml-4">
                      <div>
                        <code>vaule </code>
                        <span class="text-success">? </span>
                        <span class="text-info">this</span
                        >.example.validateDateBase = <code>false</code
                        ><span class="text-success"> : </span>
                        <span class="text-info">this</span
                        >.example.validateDateBase = <code>true</code>
                      </div>
                    </div>
                    <div>
                      }
                    </div>
                  </div>
                  <div>
                    }
                  </div>
                </div>
              </div>
            </b-card>
            <div class="row">
              <div class="col-sm-3">
                <date-base
                  @selected="onSelectedDateBase($event)"
                  :is-invalid="example.validateDateBase"
                  invalid="กรุณาเลือกวันที่"
                  :date-time="selectDateTimeBase ? true : false"
                />
              </div>
              <div class="col-sm-3">
                <button
                  class="btn btn-secondary"
                  @click="selectDateTimeBase = !selectDateTimeBase"
                >
                  <template v-if="selectDateTimeBase">Date</template
                  ><template v-else>Date Time</template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import PageHeader from '@/components/page-header'
import Switches from 'vue-switches'
import Multiselect from 'vue-multiselect'
import dateRange from '@/components/share/date-range.vue'
import dateBase from '@/components/share/date-base.vue'
import tinymce from 'vue-tinymce-editor'

export default {
  name: 'CustomElements',
  page: {
    title: 'Custom Elements',
    meta: [{ name: 'description', content: 'Custom Elements' }],
  },
  components: { 
    PageHeader,
    Switches,
    Multiselect,
    dateRange,
    dateBase,
    tinymce,
  },
  data() {
    return {
      title: 'Elements',
      itemsPageHeader: [
        {
          text: 'Custom',
          href: '/',
        },
        {
          text: 'Elements',
          active: true,
        },
      ],
      isTooltipBtn: true,
      selectInput: 1,
      selectSearch: 1,
      selectDateTime: false,
      selectDateTimeBase: false,
      disableMultiselect: false,
      isHide: false,
      isButtonCode: false,
      example: {
        text: {
          th: '',
          en: '',
          validate: '',
        },
        search: {
          btn: '',
          icon: '',
        },
        button: {
          class: 'primary',
          icon: 'bx bx-search',
          text: 'Search',
        },
        icon: {
          class: 'text-info',
          icon: 'bx bx-show',
          text: 'View',
        },
        switches: {
          isSmall: false,
        },
        status: {
          class: 'default',
          text: 'Default',
        },
        multiselectData: '',
        defaultDate: [],
        startDate: '',
        endDate: '',
        validateDateRange: false,
        validateDateBase: false,
      },
      switches: {
        default: true,
        small: true,
      },
      optionsMultiselect: [
        {
          storeType: 'Good',
          text: 'Main SubWH (Murata)',
          value: '50001',
        },
        {
          storeType: 'Good',
          text: 'Vendor stock-SubWH',
          value: '50002',
        },
        {
          storeType: 'ReturnToVendor',
          text: 'RTV-SubWH',
          value: '50004',
          $isDisabled: true,
        },
      ],
      tinymceEditor: '',
      plugins: [
        'advlist autolink link image lists charmap print preview hr anchor pagebreak spellchecker',
        'searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking',
        'save table contextmenu directionality emoticons template paste textcolor',
      ],
      toolbar:
        'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | l      ink image | print preview media fullpage | forecolor backcolor emoticons',
      options: {
        height: 200,
        // style_formats: [
        //   { title: 'Bold text', inline: 'b' },
        //   { title: 'Red text', inline: 'span', styles: { color: '#ff0000' } },
        //   { title: 'Red header', block: 'h1', styles: { color: '#ff0000' } },
        //   { title: 'Example 1', inline: 'span', classes: 'example1' },
        //   { title: 'Example 2', inline: 'span', classes: 'example2' },
        //   { title: 'Table styles' },
        //   { title: 'Table row 1', selector: 'tr', classes: 'tablerow1' },
        // ],
      },
      files: [],
    }
  },
  watch: {
    'example.multiselectData': {
      handler(val) {
        console.log(val)
      },
      deep: true,
    },
  },
  methods: {
    onExampleBtn(Cl, Icon, Text) {
      this.example.button.class = Cl
      this.example.button.icon = Icon
      this.example.button.text = Text
    },
    onExampleStatus(Cl, Text) {
      this.example.status.class = Cl
      this.example.status.text = Text
    },
    onSelectedDate(value) {
      this.example.startDate = value.from
      this.example.endDate = value.to
      this.example.startDate && this.example.endDate
        ? (this.example.validateDateRange = false)
        : (this.example.validateDateRange = true)
    },
    previewFiles() {
      this.files = this.$refs.customFile.files
    },
    onConsoleLog(e) {
      console.log(e)
    },
    onSelectedDateBase(value) {
      this.example.date = value
      value
        ? (this.example.validateDateBase = false)
        : (this.example.validateDateBase = true)
      console.log(this.example.date)
    },
  },
}
</script>
<style scoped>
.quote-code span[class*='text-'] {
  font-weight: 600;
}
.user-select-none {
  user-select: none;
  font-weight: 300;
  font-size: 12px;
}
</style>
